<template>
  <div>
    <Row>
      <Form ref="queryCarRecordsForm" :model="query" :label-width="70" label-position="right" inline
            class="index-query-form">
        <Form-item :label-width="0">
          <Input
            v-model="query.plateNo"
            placeholder="请输入车牌号"
            style="width:170px;margin-right: 10px;"
          />
          <Select v-model="query.releaseWay" style="width: 200px" class="tool-item" placeholder="放行方式">
            <Option
              v-for="item in dict.release_way"
              :value="item.dictKey"
              :key="item.dictValue"
            >
              {{ item.dictValue }}
            </Option>
          </Select>
          <span @click="handleSearch" style="margin: 0 10px;"><Button
            type="primary">{{$t('searchText')}}</Button></span>
          <Button @click="resetSearchForm" type="default">{{$t('resetText')}}</Button>
        </Form-item>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1" style="width:100%;">
      <Table ref="carRecordsTable" :columns="columns" stripe border :data="page.data"
             @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle">
        <div>
          <Page :current="page.current" :total="page.total" :page-size="page.size" @on-change="handlePageChange"
                show-elevator show-total style="padding: 10px;"></Page>
        </div>
      </Row>
    </Row>
  </div>
</template>
<script type="text/jsx">
  import Vue from 'vue'

  import api from '@/api'
  import mixin from '@/libs/mixins/Index'

  import CarRecordsForm from '@/views/travel/car-records/components/Form.vue'

  Vue.component('carRecords-form', CarRecordsForm)

  export default {
    dictParams: ['release_way', 'plate_color', 'cross_type', 'release_reason', 'cross_result'],
    name: 'aip-travel-carRecords-index',
    mixins: [mixin],
    data () {
      return {
        query: {
          plateNo: '',
          dataId: '',
          releaseWay: ''
        },
        page: {
          size: 10,
          current: 1,
          total: 0,
          sort: 'id_desc',
          loading: false,
          data: []
        },
        carRecordsDrawer: {
          action: 'add',
          visible: false,
          submiting: false
        },
        batchOperate: {
          action: 'batchDel',
          submiting: false,
          options: [
            { value: 'handleBatchRemove', label: '批量删除' }
          ]
        }
      }
    },
    methods: {
      handleSearch () {
        this.page.loading = true
        api.travel.CarRecords.query(this.query, this.page)
          .then(data => {
            this.page = Object.assign(this.page, data)
            this.page.loading = false
          }).catch(error => this.page.loading = false)
      },
      openCarRecordsDrawer (carRecords) {
        this.carRecordsDrawer.visible = true
        this.carRecordsDrawer.type = carRecords ? carRecords.type : 'add'
        this.$nextTick(() => {
          if (carRecords) {
            this.$refs['carRecordsForm'].getCarRecords(carRecords.id, carRecords.type)
          } else {
            this.$refs['carRecordsForm'].handleReset()
          }
        })
      },
      handleSubmit () {
        this.carRecordsDrawer.submiting = true
        this.$refs.carRecordsForm.handleSubmit(
          data => {
            this.carRecordsDrawer.submiting = false
            this.handleSearch()
            setTimeout(() => this.carRecordsDrawer.visible = false, 1000)
          },
          () => {
            this.carRecordsDrawer.submiting = false
          }
        )
      },
      deleteCarRecords (id) {
        api.travel.CarRecords.remove(id)
          .then(response => {
            this.$Message.success(this.$t('successText'))
            this.handleSearch()
          }).catch(error => console.log(error))
      },
      handleBatchRemove (rows) {
        this.batchOperate.submiting = true
        Promise.all(rows.map(item => api.travel.CarRecords.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false
            this.handleSearch()
          }).catch(e => {
          this.batchOperate.submiting = false
          this.handleSearch()
        })
      },
      handleBatchOperate () {
        let records = this.$refs.carRecordsTable.getSelection()
        if (records.length == 0) {
          this.$Message.warning(this.$t('errorText'))
          return
        }
        this[this.batchOperate.action](records)
      }
    },
    computed: {
      columns () {
        return [
          { key: 'plateNo', align: 'center', width: 160, title: this.$t('travel.car-records.plateNo.label') },
          {
            key: 'plateColor',
            align: 'center',
            width: 80,
            filters: this.dict.plate_color,
            filterMultiple: false,
            title: this.$t('travel.car-records.plateColor.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.plateColor == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'crossType',
            align: 'center',
            width: 80,
            filters: this.dict.cross_type,
            filterMultiple: false,
            title: this.$t('travel.car-records.crossType.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.crossType == t.dictKey).dictValue}</div>
            }
          },
          { key: 'gate', align: 'center', width: 80, title: this.$t('travel.car-records.gate.label') },
          { key: 'channel', align: 'center', width: 80, title: this.$t('travel.car-records.channel.label') },
          { key: 'crossTime', align: 'center', width: 180, title: this.$t('travel.car-records.crossTime.label'), },
          {
            key: 'releaseReason',
            align: 'center',
            width: 140,
            filters: this.dict.release_reason,
            filterMultiple: false,
            title: this.$t('travel.car-records.releaseReason.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.releaseReason == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'releaseWay',
            align: 'center',
            width: 100,
            filters: this.dict.release_way,
            filterMultiple: false,
            title: this.$t('travel.car-records.releaseWay.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.releaseWay == t.dictKey).dictValue}</div>
            }
          },
          {
            key: 'releaseResult',
            align: 'center',
            width: 100,
            filters: this.dict.cross_result,
            filterMultiple: false,
            title: this.$t('travel.car-records.releaseResult.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.releaseResult == t.dictKey).dictValue}</div>
            }
          },
          { key: 'boxNum', align: 'center', width: 80, title: this.$t('travel.car-records.boxNum.label') },
          { key: 'box', align: 'center', minWidth: 160, title: this.$t('travel.car-records.box.label') },
          { key: 'boxIso', align: 'center', width: 120, title: this.$t('travel.car-records.boxIso.label') },
          // { key: 'boxImg', align: 'left', minWidth: 120, title: this.$t('travel.car-records.boxImg.label') },

        ]
      }
    }
  }
</script>
